<div class="row">
    <div class="container-fluid pl-0 pr-0">
        <div class="row">
            <div class="col-xl-12">
                <div class="card card-header-actions mx-auto">
                    <div class="card-header">
                        Pay Web Component
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-xl-3">
                                <div class="form-group">
                                    <div>
                                        <label class="control-label">Email </label>
                                        <input type="text" class="form-control" placeholder="Enter email"
                                            [(ngModel)]="email">
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3">
                                <div class="form-group">
                                    <div>
                                        <label class="control-label">Amount </label>
                                        <input type="text" class="form-control" placeholder="Enter amount"
                                            [(ngModel)]="amount">
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3 mt-4">
                                <button class="btn btn-sm btn-success" id="Btn2" (click)="payNow()">Pay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>